webpackJsonp([230907205026964],{

/***/ 1348:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AppointmentPositionInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":"Input for updating an appointment's position in queue","name":"id","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":null,"description":null,"name":"position","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"SCALAR","name":"Int","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-appointment-position-input-906f5a814791f5d9c441.js